<section class="section-wrapper" id="second-container-lg">
  <div class="container second-container p-0 mt-4">
    <div class="row second-container-rectangle d-flex align-items-center p-5">
      <div class="left-of-rectangle col-6">
        <span class="second-section-primary-text width-81"
              [ngClass]="{'second-section-primary-text-am': currentLang === Language.HY}">{{ 'home-page-content.networking_title' | translate }}</span>
        <span class="second-section-secondary-text"
              [ngClass]="{'second-section-secondary-text-am': currentLang === Language.HY}">{{ 'home-page-content.networking_description' | translate }}</span>
        <div class="application-links">
          <a href="https://www.apple.com/app-store/" target="_blank">
            <img src="assets/homepage/social-media/app-store.svg" alt="app store link">
          </a>
          <a href="https://play.google.com/store" target="_blank">
            <img src="assets/homepage/social-media/google-play.svg" alt="google play link">
          </a>
        </div>
      </div>
      <div class="right-of-rectangle col-6">
        <img src="assets/homepage/networking-made-effortless/iphone-15.png" alt="section-2 iphone 15"
             class="section-2-image">
      </div>
    </div>
  </div>
</section>

<section class="section-wrapper-mb" id="second-container-mb">
  <div class="second-container mt-4">
    <div class="second-container-rectangle-mb">
      <img src="assets/homepage/networking-made-effortless/iphone-15-mb.png" class="section-2-image-mb"
           alt="section-2 iphone 15">
      <div class="flex-direction-column align-items-center second-section-text-container-mb">
        <div class="i-width-100">
          <span class="second-section-primary-text">{{ 'home-page-content.networking_title' | translate }}</span>
        </div>
        <div class="i-width-100 mt-20px">
          <span
            class="second-section-secondary-text">{{ 'home-page-content.networking_description' | translate }}</span>
        </div>
        <div class="application-links pt-5">
          <a href="https://www.apple.com/app-store/" target="_blank">
            <img class="mobile-app-link" src="assets/homepage/social-media/app-store.svg" alt="app store link">
          </a>
          <a href="https://play.google.com/store" target="_blank">
            <img class="mobile-app-link" src="assets/homepage/social-media/google-play.svg" alt="google play link">
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
